import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "feedback"
};
const _hoisted_2 = {
  class: "feedback-item"
};
const _hoisted_3 = {
  class: "feedback-item"
};
const _hoisted_4 = {
  class: "feedback-item"
};
const _hoisted_5 = {
  class: "feedback-item",
  style: {
    "justify-content": "center"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_alert = _resolveComponent("el-alert");
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_alert, {
    style: {
      "width": "fit-content"
    },
    type: "info",
    description: " 反馈须知：如果您在使用产品时遇到问题，或者对我们有任何意见建议，欢迎在此留言，我们会用心倾听您的建议。",
    "show-icon": ""
  }), _createElementVNode("div", _hoisted_2, [_cache[8] || (_cache[8] = _createElementVNode("p", null, "类型：", -1)), _createVNode(_component_el_radio_group, {
    modelValue: $setup.feedback.module,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.feedback.module = $event),
    class: "ml-4"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_radio, {
      label: "1",
      size: "large"
    }, {
      default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("产品界面", -1)]))]),
      _: 1
    }), _createVNode(_component_el_radio, {
      label: "2",
      size: "large"
    }, {
      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("产品功能", -1)]))]),
      _: 1
    }), _createVNode(_component_el_radio, {
      label: "3",
      size: "large"
    }, {
      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("试题质量", -1)]))]),
      _: 1
    }), _createVNode(_component_el_radio, {
      label: "4",
      size: "large"
    }, {
      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("诊断报告", -1)]))]),
      _: 1
    }), _createVNode(_component_el_radio, {
      label: "5",
      size: "large"
    }, {
      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("其他建议", -1)]))]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_3, [_cache[9] || (_cache[9] = _createElementVNode("p", null, "标题：", -1)), _createVNode(_component_el_input, {
    style: {
      "width": "60%"
    },
    modelValue: $setup.feedback.title,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.feedback.title = $event)
  }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_4, [_cache[10] || (_cache[10] = _createElementVNode("p", null, "内容：", -1)), _createVNode(_component_el_input, {
    style: {
      "width": "60%"
    },
    modelValue: $setup.feedback.suggestion,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $setup.feedback.suggestion = $event),
    type: "textarea"
  }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
    type: "primary",
    onClick: $setup.saveFeedback
  }, {
    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode("提交", -1)]))]),
    _: 1
  }, 8, ["onClick"])])]);
}